import { Box, Stack } from "@chakra-ui/react";

export const data = [
    {
        key: 'shapes-icons',
        label: "Intuitive user flows",
        description: (
            <Stack spacing={6}>
                <Box>
                    Whether you're setting up new user flows or optimizing existing pathways, it's simple to leverage Rarchy's user flow editor.
                </Box>
                <Box>
                    Make information even more accessible and show connections between different elements by adding shapes and icons from our library with just one click.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/user-flow/shapes-icons.webp"
    },
    {
        key: 'whiteboard',
        label: "Collaborative whiteboard",
        description: (
            <Stack spacing={6}>
                <Box>
                   Use our user flow editor as a real-time collaborative center for all of your flowchart needs.
                </Box>
                <Box>
                    Create multiple diagrams in a single project, with unlimited shapes, icons and connectors.
                </Box>
            </Stack>
        ),
        imgSrc: `/images/user-flow/whiteboard.webp`,
        imgH: 520
    },
    {
        key: 'link',
        label: "Link to your sitemaps",
        description: (
            <Stack spacing={6}>
                <Box>
                    Link user flows to any of your visual sitemaps and never worry about working with outdated information
                </Box>
                <Box>
                    Any changes made to linked sitemap pages are reflected immediately in user flows, and vice versa.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/user-flow/link.webp"
    },
    {
        key: 'share',
        label: "Share easily",
        description: (
            <Stack spacing={6}>
                <Box>
                    Get feedback, make changes, and keep things organized with comprehensive overviews of comments and iterations.
                </Box>
                <Box>
                    Give your team members access to your user flows, work directly with them in the editor, or export as images for use in presentations.
                </Box>
            </Stack>
        ),
        imgSrc: "/images/user-flow/share.webp"
    },
]